import { render, staticRenderFns } from "./repeatPhone.vue?vue&type=template&id=488a9646&scoped=true&"
import script from "./repeatPhone.vue?vue&type=script&lang=js&"
export * from "./repeatPhone.vue?vue&type=script&lang=js&"
import style0 from "./repeatPhone.vue?vue&type=style&index=0&id=488a9646&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488a9646",
  null
  
)

export default component.exports